// extracted by mini-css-extract-plugin
export default {"container":"Player_container__xue6E"};